import { onboardingSteps } from "./onboardingSteps"

export function getOnboardingSteps({ email, isEdit, isVerify }) {
  return onboardingSteps.map((step) =>
    typeof step === "function" ? step(email, isEdit, isVerify) : step
  )
}
